module.exports = __webpack_public_path__ + "img/1-2-1.1764d891.png";